import { useEffect, useRef } from 'react';

import debounce from 'lodash/debounce';

import { raf } from '@utils/misc';

const ScrollPositionMemory: { [key: string]: number } = {};

export const useScrollPosition = (name: string) => {
  const scrollPosition = useRef<number | null>(null);

  useEffect(() => {
    const handleScroll = debounce(
      raf(() => {
        const { scrollY } = window;
        scrollPosition.current = scrollY;
      }),
      100
    );

    const _cachedScrollPosition = ScrollPositionMemory[name] ?? 0;
    window.scrollTo(0, _cachedScrollPosition);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);

      if (scrollPosition.current !== null) {
        ScrollPositionMemory[name] = scrollPosition.current;
      }
    };
  }, [name]);

  return;
};
